import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { Routine } from 'app/modules/admin/models/routines.types';

@Component({
    selector: 'app-routine-selector-modal',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatChipsModule
    ],
    templateUrl: './routine-selector-modal.component.html',
    styleUrl: './routine-selector-modal.component.scss'
})
export class RoutineSelectorModalComponent implements OnInit {
    searchTerm: string = '';
    filteredRoutines: Routine[] = [];

    constructor(
        private dialogRef: MatDialogRef<RoutineSelectorModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { routines: Routine[] }
    ) {}

    ngOnInit(): void {
        this.filteredRoutines = [...this.data.routines];
    }

    onSearchChange(): void {
        if (!this.searchTerm) {
            this.filteredRoutines = [...this.data.routines];
            return;
        }

        const term = this.searchTerm.toLowerCase();
        this.filteredRoutines = this.data.routines.filter(routine =>
            routine.name.toLowerCase().includes(term) ||
            routine.cluster?.name.toLowerCase().includes(term) ||
            routine.routine_type?.description?.toLowerCase().includes(term) ||
            routine.divisions?.some(div => div.name.toLowerCase().includes(term))
        );
    }

    selectRoutine(routine: Routine): void {
        this.dialogRef.close(routine);
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    getDeviceCount(tableData: any): number {
        if (!tableData) return 0;
        return Object.keys(tableData).length;
    }
}
